import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../../../app/core/services/auth.service';
import { GlobalName } from '../../../../../../app/core/utils/global-name';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../shared/loading/loading.component';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css'],
  standalone:true,
  imports:[
     CommonModule,
        FormsModule,
        NgbModule,
        NgxPaginationModule,
        LoadingComponent,
        SampleSearchPipe
  ]
})
export class ForgetPasswordComponent implements OnInit {
loading:any
mailSent=false;

  constructor(
    
    private authService:AuthService,
    private router: Router,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    
  }


  sendMail(value:any){
    this.loading=true
    this.authService.sendMail(value).subscribe((res:any)=>{
      this.loading=false
      this.mailSent=true
     
    },
    (err:any)=>{
      this.loading=false
      this.toastr.error(err.error.message, 'Connexion');

    });
  }
}
